import { request } from './core';

export interface Lead {
  ID: string;
  PortfolioID: string;
  Name: string;
  Email: string;
  Message: string;
  Source: string;
  CreatedAt: string;
  HandledAt: string | null;
}

export const leadsApi = {
  listLeads: () => request<Lead[]>("GET", "/api/v1/portfolios/me/leads"),
  createLead: (l: { name: string; email: string; message?: string }) =>
    request<Lead>("POST", "/api/v1/portfolios/me/leads", { name: l.name, email: l.email, message: l.message ?? "" }),
};
